<template>
  <div class="mobileNavCtn">
    <div class="headerInfo">
      <div class="leftCtn">
        <div class="logo">
          <img :src="require('@/assets/images/logo.png')" />
        </div>
        <!-- <div class="title">博城机器人</div> -->
      </div>
      <div class="rightCtn">
        <div class="iconCtn" :class="{ 'close': showNav }" @click="showNav = !showNav">
          <div class="line line1"></div>
          <div class="line line2"></div>
          <div class="line line3"></div>
        </div>
      </div>
    </div>
    <div class="screenAll" :class="{ 'showAll': showNav }">
      <div class="navList">
        <el-menu class="el-menu-vertical-demo" router>
          <el-menu-item index="/mobile/home">
            <template slot="title">
              <div class="label">首页</div>
            </template>
          </el-menu-item>
          <el-menu-item index="/mobile/about">
            <template slot="title">
              <div class="label">关于我们</div>
            </template>
          </el-menu-item>
          <el-menu-item index="/mobile/anli">
            <template slot="title">
              <div class="label">项目案例</div>
            </template>
          </el-menu-item>
          <el-menu-item index="/mobile/news">
            <template slot="title">
              <div class="label">新闻中心</div>
            </template>
          </el-menu-item>
          <el-menu-item index="/mobile/fuwu">
            <template slot="title">
              <div class="label">投资者关系</div>
            </template>
          </el-menu-item>
          <el-menu-item index="/mobile/contact">
            <template slot="title">
              <div class="label">联系我们</div>
            </template>
          </el-menu-item>
        </el-menu>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Mobileheader',
  data() {
    return {
      showNav: false
    }
  },
  methods: {
  },
  mounted() {
    console.log('haha')
  }
}
</script>

<style lang="scss" scoped>
.mobileNavCtn {
  position: fixed;
  background: #fff;
  left: 0;
  right: 0;
  color: #000b12;
  z-index: 99;

  .headerInfo {
    height: 40px;
    display: flex;
    justify-content: space-between;
    padding: 0 20px;
    align-items: center;
    max-width: 100%;

    .leftCtn {
      display: flex;

      .logo {
        height: 32px;

        img {
          height: 100%;
        }
      }

      .title {
        font-size: 16px;
        margin-left: 12px;
        line-height: 32px;
      }
    }

    .rightCtn {
      position: relative;
      width: 25px;
      height: 100%;

      .iconCtn {
        position: relative;
        height: 100%;

        &.close {
          .line1 {
            transform-origin: left;
            transform: rotateZ(45deg);
          }

          .line2 {
            background: transparent;
          }

          .line3 {
            transform-origin: left;
            transform: rotateZ(-45deg);
          }
        }

        .line {
          position: absolute;
          height: 2px;
          background: #a0a0a0;
          width: 25px;
          transition: 0.4s ease;

          &.line1 {
            top: 10px;
          }

          &.line2 {
            top: 19px;
          }

          &.line3 {
            bottom: 10px;
          }
        }
      }
    }
  }

  .screenAll {
    position: fixed;
    background: #fff;
    top: 40px;
    bottom: calc(100% - 40px);
    left: 0;
    right: 0;
    transition: 0.4s ease;
    color: #333;
    overflow: hidden;

    &.showAll {
      bottom: 0;
    }

    .navList {
      height: 100%;

      .label {
        color: #333;
        padding: 0 20px;
        font-size: 16px;
      }

      // ::v-deep .el-submenu {
      //   padding: 0 20px;
      // }
    }
  }

}
</style>